import { Button, Col, Row, TabPane } from 'reactstrap';
import { useState } from 'react';
import { RiArrowDropLeftLine, RiArrowDropRightLine } from 'react-icons/ri';
import { toastError } from '@src/utility/Toast';
import { useLoadingGlobal } from '@src/utility/hooks/useLoadingGlobal';
import { useAuthOnboarding } from '@src/utility/hooks/useAuthOnboarding';
import apiOnboarding from '@src/services/api-onboarding';
import PreviewsWebCam from '../components/PreviewsWebCam';
import FaceApi from '../components/FaceApi';
import WebCam from '../components/WebCam';

interface SendFaceProps {
  handleChangeTabe: (tab: string) => void;
  activeTab: string | null;
  request?: Record<string, unknown>;
}

const SendFace: React.FC<SendFaceProps> = ({
  handleChangeTabe,
  activeTab,
  request,
}) => {
  const { verifyLogin } = useAuthOnboarding();
  const { showLoader, hideLoader } = useLoadingGlobal();
  const [base64, setBase64] = useState<string | null>(null);
  const handleTakeOffAgain = () => {
    setBase64((s) => null);
  };

  const handleScreenshot = (base64: string | null) => {
    setBase64(base64);
  };

  const handleSendSelfie = async () => {
    try {
      await verifyLogin();
      showLoader();
      if (request) {
        await apiOnboarding.post('api/operator/send-document', {
          idOperator: request.idOperator,
          typeDocument: 'SELFIE',
          fileBase64: base64,
        });
        setBase64(null);
        handleChangeTabe('8');
      }
      hideLoader();
    } catch (error) {
      hideLoader();
      toastError({
        title: 'Ops, algo deu errado!',
        description: 'Erro ao enviar a foto.',
      });
    }
  };

  return (
    <TabPane tabId="7">
      {/* <Row className="mb-2">
        <Col className="text-center">
          <h2 className="text-primary">Selfie</h2>
          <p>Posicione o seu rosto na frente da câmera.</p>
        </Col>
      </Row> */}
      {activeTab === '7' && base64 === null ? (
        // <FaceApi handleScreenshot={handleScreenshot} />
        <WebCam
          title="Selfie"
          description="Posicione a câmera para tirar a selfie."
          handleScreenshot={handleScreenshot}
          facingMode="user"
          selfie
        />
      ) : (
        <PreviewsWebCam
          base64={base64}
          takeOffAgain={handleTakeOffAgain}
          selfie
        />
      )}
      <Row>
        <Col className="d-flex justify-content-between">
          <Button
            size="sm"
            onClick={() => handleChangeTabe('6')}
            color="secondary"
          >
            <RiArrowDropLeftLine size={25} /> Anterior
          </Button>
          <Button
            size="sm"
            onClick={() => handleSendSelfie()}
            color="success"
            style={{ cursor: base64 ? 'pointer' : 'not-allowed' }}
            disabled={!base64}
          >
            Próximo <RiArrowDropRightLine size={25} />
          </Button>
        </Col>
      </Row>
    </TabPane>
  );
};

export default SendFace;
